import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactPageSwrInterface } from 'modules/contacts/contact-page/types/contact-page-filter-interface'
import { ContactTagsApiInterface } from 'modules/contacts/contact-page/types/contact-tags-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export function useContactTags({
  limit,
  pagination,
  filter,
  contactId,
  shouldFetch,
}: ContactPageSwrInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactTagsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ''}${
    filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ''
  }`

  const { data: contactTags, mutate } = useControlledSwr(() => {
    if (user && shouldFetch && pagination.startFromId === undefined && limit) {
      return [
        `${CONTACT_API}/contacts/${contactId}/tags?pagination[limit]=${limit}${filterApi}`,
        RequestModuleEnum.Tags,
      ]
    } else if (user && shouldFetch && pagination.startFromId && limit) {
      return [
        `${CONTACT_API}/contacts/${contactId}/tags?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`,
        RequestModuleEnum.Tags,
      ]
    }
    return null
  }, fetcher)

  return { contactTags, mutate }
}
